interface IMask {
    mask: string;
}

export const time: IMask = {
    mask: '11:11',
};
